export default __webpack_public_path__ + "static/media/manila.f0b5a982.png";